/* "Invite to self-service" on the employee profile (owner / HR): emails a set-password link. */
import { useState } from "react";
import { useInviteEmployee } from "../../data/hooks";
import { ApiError } from "../../data/provider";
import type { Employee } from "../../data/types";
import { useI18n } from "../../i18n";
import { Button, Confirm, errMsg, useToast } from "../../ui";

export default function InviteButton({ employee }: { employee: Employee }) {
  const { L } = useI18n();
  const toast = useToast();
  const m = useInviteEmployee();
  const [open, setOpen] = useState(false);
  if (employee.status === "Terminated") return null;
  const send = async () => {
    try {
      const r = await m.mutateAsync(employee.id);
      toast(L("Invitation sent to " + r.email, "تم إرسال الدعوة إلى " + r.email));
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) toast(L("This employee already has an active account", "لدى هذا الموظف حساب فعّال بالفعل"), "info");
      else if (e instanceof ApiError && e.fields?.email) toast(L("Add a valid email address to the employee first", "أضف بريدًا إلكترونيًا صحيحًا للموظف أولًا"), "bad");
      else toast(errMsg(e), "bad");
    } finally { setOpen(false); }
  };
  return (
    <>
      <Button icon="user-plus" onClick={() => setOpen(true)} data-testid="btn-invite">{L("Invite to self-service", "دعوة للخدمة الذاتية")}</Button>
      {open && (
        <Confirm title={L("Invite to employee self-service?", "دعوة إلى الخدمة الذاتية للموظفين؟")} confirmLabel={L("Send invitation", "إرسال الدعوة")} busy={m.isPending}
          body={employee.email ? L(`We'll email ${employee.email} a link to set a password. They can then see payslips, request leave and letters.`, `سنرسل إلى ${employee.email} رابطًا لتعيين كلمة المرور، ليتمكن من رؤية القسائم وطلب الإجازات والخطابات.`)
            : L("This employee has no email address yet — add one first.", "لا يوجد بريد إلكتروني لهذا الموظف بعد — أضفه أولًا.")}
          onConfirm={send} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
